document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.bundleComponent-item');
  const hiddenInput = document.getElementById('bundleComponent-input');
  const countDisplay = document.getElementById('bundleComponent-count');

  if (!hiddenInput) return;

  const form = hiddenInput.closest('form');
  const addToCartBtn = form.querySelector('[name="add"]');

  function updateUI() {
    const selected = [];
    let index = 1;

    form.querySelectorAll('[data-bundle-prop]').forEach(el => el.remove());

    items.forEach(item => {
      const checkbox = item.querySelector('.bundleComponent-checkbox');
      const badge = item.querySelector('.bundleComponent-index');

      if (checkbox.checked) {
        item.classList.add('selected');
        badge.textContent = index;

        const variantId = checkbox.dataset.variantId;
        const productTitle = checkbox.dataset.productTitle || '';
        const variantTitle = checkbox.dataset.variantTitle || '';

        selected.push(`gid://shopify/ProductVariant/${variantId}`);

        // ADD PROPERTY INPUT
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = `properties[Sample ${index}]`;
        input.value = variantTitle
          ? `${productTitle} - ${variantTitle}`
          : productTitle;
        input.setAttribute('data-bundle-prop', 'true');

        form.appendChild(input);

        index++;
      } else {
        item.classList.remove('selected');
        badge.textContent = '';
      }
    });

    const count = selected.length;

    countDisplay.textContent = `${count} / 5`;
    hiddenInput.value = JSON.stringify(selected);

    items.forEach(item => {
      const cb = item.querySelector('.bundleComponent-checkbox');

      if (!cb.checked && count >= 5) {
        cb.disabled = true;
        item.classList.add('bundleComponent-disabled');
      } else {
        cb.disabled = false;
        item.classList.remove('bundleComponent-disabled');
      }
    });

    if (count === 5) {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('disabled');
    } else {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('disabled');
    }
  }

  function resetBundle() {
    items.forEach(item => {
      const checkbox = item.querySelector('.bundleComponent-checkbox');
      const badge = item.querySelector('.bundleComponent-index');

      checkbox.checked = false;
      checkbox.disabled = false;

      item.classList.remove('selected', 'bundleComponent-disabled');
      badge.textContent = '';
    });

    hiddenInput.value = '[]';
    countDisplay.textContent = '0 / 5';

    form.querySelectorAll('[data-bundle-prop]').forEach(el => el.remove());

    addToCartBtn.disabled = true;
    addToCartBtn.classList.add('disabled');
  }

  document.querySelectorAll('.bundleComponent-checkbox').forEach(cb => {
    cb.addEventListener('change', updateUI);
  });

  window.addEventListener('itemadded', () => {
    resetBundle();
  });

  resetBundle();
});